import type { TFunction } from "i18next";
import * as yup from "yup";

export const getGenderSchema = (t: TFunction) =>
  yup
    .string()
    .oneOf(["male", "female"], t("COMMONS.ERRORS.REQUIRED"))
    .nullable()
    .required(t("COMMONS.ERRORS.REQUIRED"));
